export default __webpack_public_path__ + "static/media/legs-lowered.51dcf0b0.png";